import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDashboardPolling } from '../hooks/useDashboardPolling';
import { useCursorHide } from '../hooks/useCursorHide';
import { DashboardErrorBoundary } from '../components/dashboard/DashboardErrorBoundary';
import { AreaContentPanel } from '../components/dashboard/AreaContentPanel';
import { FunSectionPanel } from '../components/dashboard/FunSectionPanel';
import { ConnectivityIndicator } from '../components/dashboard/ConnectivityIndicator';
import { BackgroundSlideshow } from '../components/dashboard/BackgroundSlideshow';
import { ChaptersTimeline } from '../components/dashboard/ChaptersTimeline';
import '../styles/dashboard.css';

const REFRESH_INTERVAL_MS = 30_000;
const RELOAD_INTERVAL_MS = 4 * 60 * 60 * 1000; // 4 hours
const CURSOR_HIDE_DELAY_MS = 3000;

export function PublicDashboardPage() {
  const { area } = useParams<{ area: string }>();
  const { data, isOffline } = useDashboardPolling(area!, REFRESH_INTERVAL_MS);

  useCursorHide(CURSOR_HIDE_DELAY_MS);

  // 4-hour auto-reload to clear accumulated browser memory
  useEffect(() => {
    const reloadTimer = window.setTimeout(() => {
      window.location.reload();
    }, RELOAD_INTERVAL_MS);

    return () => {
      window.clearTimeout(reloadTimer);
    };
  }, []);

  return (
    <DashboardErrorBoundary>
      <div className="dashboard-root" style={{ position: 'relative' }}>
        <BackgroundSlideshow items={data?.mediaItems ?? []} cycleInterval={20_000} />
        {isOffline && <ConnectivityIndicator />}
        <div style={{ position: 'relative', zIndex: 1, overflow: 'hidden' }}>
          <AreaContentPanel area={area!} data={data} />
        </div>
        <div style={{ position: 'relative', zIndex: 1, overflow: 'hidden' }}>
          <FunSectionPanel items={data?.funContent ?? []} cycleInterval={15_000} />
        </div>
        <div style={{ position: 'relative', zIndex: 1, gridColumn: '1 / -1' }}>
          <ChaptersTimeline chapters={data?.chaptersTimeline} />
        </div>
      </div>
    </DashboardErrorBoundary>
  );
}
